"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToUtcDate = void 0;
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
function cov_sbzepbh7v() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/dateUtils.js";
  var hash = "2423cf9fbf92c591dff9501b344f3ca5664b2cb0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/dateUtils.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 32
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 18
        },
        end: {
          line: 8,
          column: 32
        }
      },
      "2": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 11,
          column: 3
        }
      },
      "3": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 16
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 79
        }
      },
      "5": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 17
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 32
          },
          end: {
            line: 7,
            column: 33
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2423cf9fbf92c591dff9501b344f3ca5664b2cb0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_sbzepbh7v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_sbzepbh7v();
cov_sbzepbh7v().s[0]++;
/**
 * Return native Date object in standard UTC timezone or null if error happen
 * Consider to use this if you want to create a Date object exactly time of string "date" params
 * @param date: string
 */
// eslint-disable-next-line import/prefer-default-export
var convertToUtcDate = exports.convertToUtcDate = function convertToUtcDate(date) {
  cov_sbzepbh7v().f[0]++;
  var UTCDate = (cov_sbzepbh7v().s[1]++, new Date(date));
  cov_sbzepbh7v().s[2]++;
  if (UTCDate.toString() === 'Invalid Date') {
    cov_sbzepbh7v().b[0][0]++;
    cov_sbzepbh7v().s[3]++;
    return null;
  } else {
    cov_sbzepbh7v().b[0][1]++;
  }
  cov_sbzepbh7v().s[4]++;
  UTCDate.setTime(UTCDate.getTime() + UTCDate.getTimezoneOffset() * 60 * 1000);
  cov_sbzepbh7v().s[5]++;
  return UTCDate;
};